import React from 'react';
import { Heart, Users, Utensils, Sparkles } from 'lucide-react';

const items = [
  {
    icon: Utensils,
    title: 'Provide a meal',
    desc: 'R10 = 1 meal for a child in need. Donate any amount to feed hungry families.',
    color: 'from-[#F55B26] to-[#FF8A3D]',
  },
  {
    icon: Users,
    title: 'Volunteer',
    desc: 'Join our team at any of our 6 communities across Gauteng and the Western Cape. All hands welcome.',
    color: 'from-[#2196F3] to-[#42A5F5]',
  },
  {
    icon: Heart,
    title: 'Sponsor a session',
    desc: 'R150 sponsors a full 50-min counselling session at Hello Support (2027).',
    color: 'from-[#EC407A] to-[#F06292]',
  },
  {
    icon: Sparkles,
    title: 'Partner with us',
    desc: 'Corporate partnerships that create meaningful, measurable community impact.',
    color: 'from-[#8E24AA] to-[#AB47BC]',
  },
];

const GetInvolved = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-4 py-1.5 bg-[#0B3B44]/5 text-[#0B3B44] font-semibold text-xs uppercase tracking-widest rounded-full mb-4">
            Get Involved
          </div>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0B3B44] leading-tight">
            Four ways to <span className="text-[#F55B26]">make a difference.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <button
                key={i}
                onClick={() => scrollTo('#donate')}
                className="group relative text-left p-7 rounded-3xl bg-gradient-to-br from-white to-[#FFF7F1] border border-slate-100 hover:border-[#F55B26]/30 hover:shadow-xl transition-all hover:-translate-y-1"
              >
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-md mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-extrabold text-lg text-[#0B3B44] mb-2">{item.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{item.desc}</p>
                <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#F55B26]/0 group-hover:bg-[#F55B26]/10 flex items-center justify-center transition-colors">
                  <span className="text-[#F55B26] opacity-0 group-hover:opacity-100 transition-opacity">→</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GetInvolved;
